export const links = [
    {
        name: 'About',
        route: '/me',
    },
    {
        name: 'Projects',
        route: '/projects',
    },
    {
        name: 'Blog',
        route: '/blog',
    },
]